import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstPd5: [],
        pd5: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false
    },
    getters: {
        
    },
    mutations: {
        set(state, pd5){
            state.pd5 = pd5
            if (pd5)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
            state.pd5 = null
        },
        setParamsDataTable(state, payload){
            state.lstPd5 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
    },
    actions: {
        initForm(store){
            store.commit("initForm")
        },
        async find(store, pd5codigo){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get(`/OryxPdv/MallParameters/Find/${pd5codigo}`)
            .then(response => {
                let pd5 = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", pd5)
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
        },
        save(store){
            if (store.state.pd5.pd5codigo){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/OryxPdv/MallParameters/Insert", store.state.pd5 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/parametros-shopping")
                store.state.pd5 = null
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/OryxPdv/MallParameters/Update", store.state.pd5 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/parametros-shopping")
                store.state.pd5 = null
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete(`/OryxPdv/MallParameters/Delete/${store.state.pd5.pd5codigo}`)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/parametros-shopping")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async findList(store){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get("/OryxPdv/MallParameters/FindAll")
            .then(response => {
                let lstPd5 = Utils.ValidateAxiosResponse(response.data);
                store.state.lstPd5 = lstPd5
                store.state.hasNext = lstPd5.length > store.state.itemsPerPage
            }).catch(error => {
                store.state.lstPd5 = []
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            })
            store.state.loading = false
        },
    }
}